module.exports = __webpack_public_path__ + "img/dvrs.2c38fe55.svg";